var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Error_svg__[object_Object]c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F06A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DE2612"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Error_svg__[object_Object]a",
    width: "123.1%",
    height: "123.1%",
    x: "-11.5%",
    y: "-11.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "shadowSpreadInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.984313725 0 0 0 0 0.866666667 0 0 0 0 0.847058824 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Error_svg__[object_Object]b",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    rx: 13
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#Error_svg__[object_Object]a)",
    xlinkHref: "#Error_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Error_svg__[object_Object]c)",
    d: "M9 1a8 8 0 017.996 7.75L17 9a8 8 0 01-7.75 7.996L9 17A8 8 0 019 1zm0 10.752a1.25 1.25 0 00-1.244 1.122l-.006.128.006.127a1.25 1.25 0 001.116 1.116l.128.007.128-.007A1.25 1.25 0 009 11.752zM8.174 4l-.084.006c-.192.03-.338.169-.34.335v.02l.38 5.815.013.067c.049.15.215.259.41.257h.893l.082-.006c.185-.028.33-.157.342-.318l.38-5.816-.005-.07c-.031-.158-.194-.283-.397-.29H8.174z",
    transform: "translate(4 4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default ForwardRef;